module.exports = __webpack_public_path__ + "img/caleta.9b9ac5e6.19f82091.png";